module.exports = __webpack_public_path__ + "static/media/green-checkmark-line.33232ccd.svg";